/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { FrameTextBlockData } from './FrameTextBlockData'
import {
  FrameTextBlockDataFromJSON,
  FrameTextBlockDataFromJSONTyped,
  FrameTextBlockDataToJSON,
} from './FrameTextBlockData'

/**
 *
 * @export
 * @interface TableBlock
 */
export interface TableBlock {
  /**
   *
   * @type {string}
   * @memberof TableBlock
   */
  type: TableBlockTypeEnum
  /**
   *
   * @type {FrameTextBlockData}
   * @memberof TableBlock
   */
  data: FrameTextBlockData
}

/**
 * @export
 * @enum {string}
 */
export enum TableBlockTypeEnum {
  TableBlock = 'table_block',
}

/**
 * Check if a given object implements the TableBlock interface.
 */
export function instanceOfTableBlock(value: object): value is TableBlock {
  if (!('type' in value) || value['type'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function TableBlockFromJSON(json: any): TableBlock {
  return TableBlockFromJSONTyped(json, false)
}

export function TableBlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TableBlock {
  if (json == null) {
    return json
  }
  return {
    type: json['type'],
    data: FrameTextBlockDataFromJSON(json['data']),
  }
}

export function TableBlockToJSON(value?: TableBlock | null): any {
  if (value == null) {
    return value
  }
  return {
    type: value['type'],
    data: FrameTextBlockDataToJSON(value['data']),
  }
}
